/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowBendUpRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M229.65723,109.65723l-48,48A8.00066,8.00066,0,0,1,168,152V112H128a88.09957,88.09957,0,0,0-88,88,8,8,0,0,1-16,0A104.11791,104.11791,0,0,1,128,96h40V56a8.00065,8.00065,0,0,1,13.65723-5.65723l48,48A8.00122,8.00122,0,0,1,229.65723,109.65723Z" />
    </Svg>
  );
}

export default ArrowBendUpRight;
